import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-[#A3A3A3] font-mono text-sm">
        loading workspace…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
